const config = {
  host: `${process.env.REACT_APP_HOST}`,
  protocol: `${process.env.REACT_APP_PROTOCOL}`,
  port: `${process.env.REACT_APP_PORT}`,
  apiPath: `${process.env.REACT_APP_API_PATH}`,
  adminPath: `${process.env.REACT_APP_ADMIN_PATH}`,
  adminUrl: `${process.env.REACT_APP_ADMIN_URL || 'https://globalandxl.nl/admin'}`,
  development: process.env.NODE_ENV === 'development',
  mediaUrl: `${process.env.REACT_APP_MEDIA_URL}`,
  uploadsUrl: `${process.env.REACT_APP_UPLOADS_URL}` || 'http://uploads.globalandxl.nl',
  disableDesktop: `${process.env.REACT_APP_DISABLE_DESKTOP}`,
};

config.ghettoRadioUrl = process.env.REACT_APP_GHETTORADIO_URL ? process.env.REACT_APP_GHETTORADIO_URL : `${config.protocol}//ghettoradio}.${config.host}`;
config.apiUrl = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : `${config.protocol}//${config.host}${config.apiPath}`;

// eslint-disable-next-line
config.socketIoHost = /([a-z]+):\/\/([^\/]+)/.exec(config.apiUrl)[0];
config.socketIoOptions = {
  path: process.env.REACT_APP_SOCKET_IO_PATH || '/api/socket.io',
};
config.socketIoUrl = config.socketIoHost + config.socketIoOptions.path + '/socket.io.js';

module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js